<template>
    <div class="relative my-6">
        <h3 class="text-semibold mb-1 mt-0 text-gray-700">
            {{ phoneRepresentative.name }}
            <span v-if="canSeeAverageBottlesPerSale"
                >- ({{ (average / 100).toFixed(2) }} bottles per sale)</span
            >
        </h3>

        <div class="overflow-hidden h-5 mb-4 text-xs flex rounded bg-gray-100">
            <div
                role="progressbar"
                style="min-width: 20px"
                :style="{ width: progressBarWidth }"
                class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-nutreance-green"
                :aria-valuenow="count"
                aria-valuemin="0"
                :aria-valuemax="topSalesTier"
            >
                {{ count > 0 ? count : 0 }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
    phoneRepresentative?: any;
    canSeeAverageBottlesPerSale?: string;
    timeFrame?: string;
    topSalesTier: number;
}>();

const average = computed(() =>
    props.timeFrame === "current"
        ? props.phoneRepresentative.currentMonthAverage
        : props.phoneRepresentative.lastMonthAverage,
);
const count = computed(() =>
    props.timeFrame === "current"
        ? props.phoneRepresentative.currentMonthCount
        : props.phoneRepresentative.lastMonthCount,
);
const progressBarWidth = computed(
    () =>
        (count.value > props.topSalesTier
            ? 100
            : (count.value * 100) / props.topSalesTier) + "%",
);
</script>
